import styled from 'styled-components';
import Card from '@material-ui/core/Card';

export const CreatorCardWrapper = styled(Card)`
    && {
        h4,
        .paragraph {
            color: ${(p) => p.theme.palette.neutral.steel};
        }
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        text-align: center;
        align-items: center;
        min-height: auto;
        height: auto;
        &.video-card {
            height: 558px;
            box-sizing: border-box;
        }
        ${(p) => p.theme.breakpoints.up('xs')} {
            width: 100%;
            padding: ${(p) => p.theme.spacing(4)}px;
        }
        ${(p) => p.theme.breakpoints.up('sm')} {
            padding: ${(p) => p.theme.spacing(4)}px ${(p) => p.theme.spacing(12)}px;
        }
        ${(p) => p.theme.breakpoints.up('md')} {
            width: 33.33333%;
            &.video-card {
                width: 25%;
            }
            padding: ${(p) => p.theme.spacing(6)}px;
        }
        border-radius: unset;
        box-shadow: none;
        &.pearl {
            background-color: ${(p) => p.theme.palette.neutral.pearl};
        }
        &.chalk {
            background-color: ${(p) => p.theme.palette.neutral.chalk};
        }
        .ue-outlined-card {
            z-index: 1;
            pointer-events: none;
            position: absolute;
            border-image-width: 4px;
            max-width: 100%;
            min-height: auto;
            top: 24px;
            right: 24px;
            bottom: 24px;
            left: 24px;
            transition: top 0.25s ${(p) => p.theme.easing}, right 0.25s ${(p) => p.theme.easing},
                bottom 0.25s ${(p) => p.theme.easing}, left 0.25s ${(p) => p.theme.easing};
        }
        &.active .ue-outlined-card {
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transition: top 0.25s ${(p) => p.theme.easing}, right 0.25s ${(p) => p.theme.easing},
                bottom 0.25s ${(p) => p.theme.easing}, left 0.25s ${(p) => p.theme.easing};
        }
        a.ue-link-wrap {
            color: ${(p) =>
                p.theme.ifLight(p, p.theme.palette.text.primary, p.theme.palette.common.black)};
            float: none;
            max-width: calc(100% + ${(p) => p.theme.spacing(6)}px);
            ${(p) => p.theme.breakpoints.down('xs')} {
                max-width: calc(100% + ${(p) => p.theme.spacing(2)}px);
            }
        }
        h3 {
            text-overflow: ellipsis;
            overflow: hidden;
            color: ${(p) => p.theme.palette.common.black};
        }
        h4 {
            margin-bottom: 0;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .eyebrow-wrapper {
            ${(p) => p.theme.breakpoints.up('xs')} {
                margin-bottom: ${(p) => p.theme.spacing(3)}px;
            }
            ${(p) => p.theme.breakpoints.up('sm')} {
                margin-bottom: ${(p) => p.theme.spacing(4)}px;
            }
        }
        .paragraph {
            margin: ${(p) => p.theme.spacing(1)}px auto auto auto;
            max-width: ${(p) => p.theme.spacing(63)}px;
        }
        &.video-card .paragraph {
            margin: 0 auto ${(p) => p.theme.spacing(2)}px auto;
        }
        a {
            .secondary {
                margin-top: ${(p) => p.theme.spacing(3)}px;
                min-height: ${(p) => p.theme.spacing(6)}px;
                width: ${(p) => p.theme.spacing(18)}px;
                height: ${(p) => p.theme.spacing(6)}px;
            }
            .tertiary {
                margin-bottom: 6px;
            }
            .secondary span,
            .tertiary span {
                color: ${(p) =>
                    p.theme.ifLight(p, p.theme.palette.text.primary, p.theme.palette.common.black)};
            }
        }
        &.active a .tertiary {
            z-index: -1;
        }
        .with-caption {
            height: auto;
        }
        &.inactive {
            a.ue-link-wrap {
                overflow: hidden;
            }
            .copy-container {
                position: absolute;
                bottom: 0;
                padding: 32px 48px 48px 48px;
                box-sizing: border-box;
                width: 100%;
                &.pearl {
                    background-color: ${(p) => p.theme.palette.neutral.pearl};
                }
                &.chalk {
                    background-color: ${(p) => p.theme.palette.neutral.chalk};
                }
            }
        }
        &.active {
            background-color: ${(p) => p.theme.palette.common.black};
            .ue-onclick-wrap {
                z-index: 2;
                opacity: 0;
                transition: opacity 0.5s ease-in;
                position: absolute;
                top: 0;
                left: 0;
                height: ${(p) => p.theme.spacing(9)}px;
                width: 100%;
                background: linear-gradient(
                    180deg,
                    ${(p) => p.theme.palette.common.black},
                    rgba(14, 17, 40, 0) 100%
                );
                .ue-icon-arrow-left {
                    top: ${(p) => p.theme.spacing(3)}px;
                    left: ${(p) => p.theme.spacing(3)}px;
                    position: absolute;
                    cursor: pointer;
                }
            }
        }
    }
`;

export const CreatorCardImage = styled.div`
    display: flex;
    margin-bottom: ${(p) => p.theme.spacing(3)}px;
    img {
        border-radius: 100%;
    }
`;

export const CreatorCardActive = styled.div`
    && {
        position: absolute;
        z-index: 0;
        height: 100%;
        width: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        video {
            z-index: 1;
            background-color: ${(p) => p.theme.palette.common.black};
            width: 100%;
            height: 100%;
            object-position: top;
        }
        &:hover {
            .ue-onclick-wrap {
                opacity: 0.9;
                transition: opacity 0.1s ease-out;
        }
    }
`;

export const CreatorCardInactive = styled.div`
    position: absolute;
    z-index: 0;
    height: 366px;
    width: calc(100% - ${(p) => p.theme.spacing(3)}px);
    top: 12px;
    right: 12px;
    left: 12px;
    ${(p) => p.theme.breakpoints.down('sm')} {
        cursor: pointer;
    }
    .video-card-play-icon {
        cursor: pointer;
        z-index: 1;
        display: flex;
        visibility: visible;
        position: absolute;
        top: calc(100% - ${(p) => p.theme.spacing(28)}px);
        left: calc(50% - ${(p) => p.theme.spacing(6)}px);
    }
`;
